import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({
  title = "Teledoc - Online Doctor Consultation & Telemedicine Platform",
  description = "Get instant online doctor consultation with certified doctors. Book appointments and access healthcare from home. 24/7 telemedicine services.",
  keywords = "online doctor consultation, telemedicine, virtual doctor, healthcare, medical consultation, doctor appointment, telemedicine platform",
  canonical = "",
  ogImage = "/static/media/banner_img.69b76a82725c35db4a36.png",
  ogType = "website",
  structuredData = null,
  noIndex = false
}) => {
  const siteUrl = "https://teledoc.co.in";
  const fullCanonical = canonical ? `${siteUrl}${canonical}` : siteUrl;
  const fullOgImage = ogImage.startsWith('http') ? ogImage : `${siteUrl}${ogImage}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Teledoc Telemedicine Platform" />
      <meta name="robots" content={noIndex ? "noindex,nofollow" : "index,follow"} />
      <link rel="canonical" href={fullCanonical} />

      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullOgImage} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="Teledoc - Telemedicine Platform" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullOgImage} />
      <meta name="twitter:site" content="@Teledoc_telemed" />
      <meta name="twitter:creator" content="@Teledoc_telemed" />

      {/* Additional SEO Meta Tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="theme-color" content="#4CAF50" />
      <meta name="msapplication-TileColor" content="#4CAF50" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="apple-mobile-web-app-title" content="Teledoc" />

      {/* Medical/Healthcare Specific Meta Tags */}
      <meta name="medical-specialty" content="General Practice, Telemedicine, Online Consultation" />
      <meta name="healthcare-provider" content="Teledoc Telemedicine Platform" />
      <meta name="service-area" content="India, Online Consultation" />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;
